export const asyncWait = <T>(ms: number, data?: T) => new Promise<T | undefined>(resolve => {
  setTimeout(() => resolve(data), ms);
});
